const Vue = require('vue')
const R = require('ramda')
const bus = require('sci/std/bus')

Vue.component('form-group-count', {
    props: {
        form: {
            type: String,
            required: true
        },
        fields: {
            type: Array,
            required: true
        }
    },
    methods: {},
    data () {
        return {
            errors: []
        }
    },
    ready () {
        bus.$on(`${this.form}:errors`, (errors) => {
            this.errors = Object.keys(errors).filter((e) => {
                return this.fields.indexOf(e) !== -1
            }).map((key) => {
                return errors[key]
            })
        })
    },
    template: `
            <div v-if="errors.length > 0" class="badge badge-danger" v-tooltip title="Erros foram encontrados">
                {{ errors.length }}
            </div>
        `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/group-count.js